import { apiGet, apiPost } from './client.js';

export type OverrideRequestStatus =
  | 'pending'
  | 'approved'
  | 'denied'
  | 'expired'
  | 'cancelled';

export type OverrideRequestDto = {
  id: string;
  tenantId: string;
  storeId: string;
  action: string;
  requiredRole: string;
  requestedBy: string;
  requestedByName: string;
  reason: string | null;
  context: Record<string, unknown>;
  ticketId: string | null;
  customerId: string | null;
  status: OverrideRequestStatus;
  approvedBy: string | null;
  approvedByName: string | null;
  approvedAt: string | null;
  deniedBy: string | null;
  deniedByName: string | null;
  deniedAt: string | null;
  denialReason: string | null;
  approvalMethod: string | null;
  escalationLevel: number;
  notifiedUserIds: string[];
  expiresAt: string;
  createdAt: string;
  requesterOverrideCount7d: number;
  notifiedNames?: string[];
};

export const overrideRequestsApi = {
  create(body: {
    action: string;
    requiredRole?: 'store_manager' | 'tenant_admin';
    reason: string;
    context?: Record<string, unknown>;
    ticketId?: string;
    customerId?: string;
  }) {
    return apiPost<OverrideRequestDto, typeof body>('/api/v1/override-requests', body).then(
      (r) => r.data,
    );
  },

  get(id: string) {
    return apiGet<OverrideRequestDto>(`/api/v1/override-requests/${id}`).then((r) => r.data);
  },

  list(params?: { status?: string; scope?: string }) {
    const q = new URLSearchParams();
    if (params?.status) q.set('status', params.status);
    if (params?.scope) q.set('scope', params.scope);
    const qs = q.toString();
    return apiGet<OverrideRequestDto[]>(
      `/api/v1/override-requests${qs ? `?${qs}` : ''}`,
    ).then((r) => r.data);
  },

  pendingCount() {
    return apiGet<{ count: number }>('/api/v1/override-requests/pending-count').then((r) => r.data);
  },

  approve(id: string) {
    return apiPost<OverrideRequestDto, Record<string, never>>(
      `/api/v1/override-requests/${id}/approve`,
      {},
    ).then((r) => r.data);
  },

  deny(id: string, reason: string) {
    return apiPost<OverrideRequestDto, { reason: string }>(
      `/api/v1/override-requests/${id}/deny`,
      { reason },
    ).then((r) => r.data);
  },

  cancel(id: string) {
    return apiPost<OverrideRequestDto, Record<string, never>>(
      `/api/v1/override-requests/${id}/cancel`,
      {},
    ).then((r) => r.data);
  },
};
